import type { FaireProductEntity } from "../../entity_types/product";

export const p_5ev5e97mm6: FaireProductEntity = {
  token: "p_5ev5e97mm6",
  type: "product",
  name: "Knit Booties, White",
  brandToken: "b_4ivwmhbmyd",
  brandName: "SpearmintLOVE",
  imageUrl:
    "https://cdn.faire.com/fastly/c0bf202b9ced040882a2f5a135e9a3044b44184f6dcc2018d84eb2588c7424b3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0c1ecda97ddb81bd587b75fdb5444846ecdbcfacb8627b9b6f23236850783353.jpeg",
    "https://cdn.faire.com/fastly/ef5c551a5b7cc935d6353804001e5074c10350a90d94d4c98794833af8db6a99.jpeg",
    "https://cdn.faire.com/fastly/7c18eaa47390369e665ccad8256f0d41a63d98503e7fac1b33485310581787f5.png",
    "https://cdn.faire.com/fastly/d3bf59c62bdb402a13aaf032619c0e9979547e94a4ce1880bd26e028342f9219.jpeg",
    "https://cdn.faire.com/fastly/5327fda405742341ba5f118846c14092265e3b498adbe40e30a96feb9a06fd41.jpeg",
  ],
  priceDollars: 6.49,
  description:
    "Keep little feet cozy and stylish with our knit baby booties. Crafted from 100% pure sheep wool, these soft booties offer gentle warmth and comfort. The adjustable tie at the ankle ensures a snug, custom fit, growing with your baby for extended wear. Easy to care for—hand wash and line dry to keep them looking their best. Perfect for gifting or treating your own little one!\n",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:58.144Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
